import { baseRequest } from '@/api';
import Turntable from '@/utils/lottery.js';
import i18n from '@/lang';
import { urlParser } from '@/utils';
import { LS_PREFIX } from '@/config';
import { Bus } from '@/utils/eventBus.js';
import Base64 from '@/utils/base64js.min.js';
import LS from '@/utils/storage.js';

// 抽奖锁
let drawLock = false;

// 转盘奖品索引和奖品id映射
const rewardMap = {
    // 2: 0,
    2: 0,
    3: 1,
    4: 3,
    5: 4,
    6: 5,
    7: 6,
    8: 7,
    9: 2,
    0: 8 // 未中奖或再来一次
};

let g_share_tips_timer = null; // 分享提示浮窗定时器
let g_share_tips_pop_count = 0; // 分享提示浮窗提示次数
let g_share_tips_pop_max = 9999; // 分享提示浮窗提示最大次数

const actions = {
    /**
     * 显示通用弹窗
     * @param {String} text  通用弹窗文本
     */
    showComm(
        { state, commit },
        { text, hasCls = true, size = 'big', hasDownload = false }
    ) {
        commit('SET_STATE', {
            key: 'commText',
            val: {
                text,
                hasCls,
                size,
                hasDownload
            }
        });
        commit('SHOW_POPUP', 'comm');
    },
    // 分享提示浮窗
    popShareTips({ state, commit }) {
        if (state.createingSharePic) return;
        if (g_share_tips_pop_count >= g_share_tips_pop_max) return;
        g_share_tips_pop_count++;
        clearTimeout(g_share_tips_timer);
        commit('SHOW_POPUP', 'shareTips');
        g_share_tips_timer = setTimeout(() => {
            commit('HIDE_POPUP', 'shareTips');
        }, 3000);
    },
    // 确认领养龙
    async confirmDragon({ state, commit }, data) {
        console.log('确认领养并对战', data);
        // const data = data;
        const request_obj = {
            url: 'v1/dragon/check',
            data,
            lang: state.lang,
            token: state.token
        };
        const result = await baseRequest(request_obj);
        if (result.code == 1) {
            // 保存成功
            // 开始第一场对NPC的PK（如果连接带参数，则与玩家PK）
            const myurl = urlParser(location.href);
            // myurl.data('userid');
            // myurl.data('username');
            let _friendUserId = myurl.data('userid');
            let _friendUserName = myurl.data('username');
            let _friendDragonId = myurl.data('dragonid');
            let _hasFriendId =
                _friendUserId && _friendUserName && _friendDragonId;
            let _enemy = _hasFriendId
                ? {
                      id: gameAni.getDragonDataByTrueId(_friendDragonId).ename,
                      name: Base64.decode(_friendUserName),
                      user_id: _friendUserId
                  }
                : null;
            console.log('首次注册，与玩家PK', _enemy);
            Bus.$emit('_startPk', _enemy);
            // 更新本地userinfo的龙信息
            let _userDragon = gameAni.getDragonDataById(gameAni.myDragonId);
            commit('SET_USERINFO', {
                dragon_id: _userDragon.id,
                dragon_ename: _userDragon.ename,
                dragon_name: _userDragon.name
            });
        } else {
            console.log(result.msg);
        }
    },
    // 获取配置
    async getConfigs({ state, commit }) {
        const request_obj = {
            url: 'v1/config/get',
            lang: state.lang
        };
        const result = await baseRequest(request_obj);
        if (result.code == 1) {
            console.log(result);
            commit('SET_STATE', {
                key: 'activeId',
                val: result.data.active_id
            });
            commit('SET_STATE', {
                key: 'activeId300',
                val: result.data.active_id_300
            });
            commit('SET_STATE', {
                key: 'activeId600',
                val: result.data.active_id_600
            });
            commit('SET_STATE', {
                key: 'activeIdFirst',
                val: result.data.active_id_battle_first
            });
        } else {
            console.log(result.msg);
        }
    },
    // 更新用户数据
    async updateUserInfo({ state, commit }) {
        const request_obj = {
            url: 'v1/user/info',
            lang: state.lang,
            token: state.token
        };
        const result = await baseRequest(request_obj);
        if (result.code == 1) {
            commit('SET_STATE', {
                key: 'userinfo',
                val: result.data
            });
        }
    },
    // 获取我的信息
    async getUserInfo({ state, commit }) {
        const request_obj = {
            url: 'v1/user/info',
            lang: state.lang,
            token: state.token
        };
        const result = await baseRequest(request_obj);
        if (result.code == 1) {
            const data = result.data;
            commit('SET_STATE', {
                key: 'userinfo',
                val: data
            });
            // 如果当前是战力页，则跳过后续判断
            if (state.game.view == 'user') return;
            // 首页登录
            if (!data.user_name) {
                // 无用户名 第一次流程
                commit('SET_STATE', {
                    key: 'toolbarType',
                    val: ''
                });
                commit('SHOW_POPUP', 'saveName');
                // setTimeout(() => {
                //     Bus.$emit('_goPage', 'create');
                // }, 500);
            } else {
                // 有用户名
                // 判断是否有领养龙龙
                if (data.dragon_id) {
                    commit('SET_STATE', {
                        key: 'toolbarType',
                        val: 'main2'
                    });
                    // 链接是否有好友参数（有则发起好友PK）
                    // 无则获取最近PK记录，和本地缓存对比（时间戳）
                    // Bus.$emit('_initPage');// 0710
                } else {
                    console.log(`有用户名${data.user_name}无龙`);
                    commit('SET_GAME_STATE', {
                        key: 'user_name',
                        value: data.user_name
                    });
                    // Bus.$emit('_goPage', 'create', () => {});// 0710
                }
            }
        } else {
            LS.remove(LS_PREFIX + 'token');
            const myurl = urlParser(location.href);
            myurl.data('code', '');
            myurl.data('channel', '');
            location.href = myurl.url();
        }
    },
    // 获取登录token
    async getToken({ state, commit, dispatch }, data) {
        const request_obj = {
            url: 'v1/login/token',
            data,
            lang: state.lang
        };
        const result = await baseRequest(request_obj);
        console.log(result);
        if (result.code == 1) {
            const token = result.data.token;
            LS.save(LS_PREFIX + 'token', token, 1000 * 60 * 30);
            commit('SET_STATE', {
                key: 'token',
                val: token
            });
            dispatch('getUserInfo');
        } else {
            // token获取第三方用户信息失败或者token过期
            const myurl = urlParser(location.href);
            myurl.data('code', '');
            myurl.data('channel', '');
            location.href = myurl.url();
        }
    },
    // 保存用户名
    async saveName({ state, commit, dispatch }, data) {
        const request_obj = {
            url: 'v1/user/name',
            lang: state.lang,
            data,
            token: state.token
        };
        const result = await baseRequest(request_obj);
        if (result.code == 1) {
            commit('HIDE_POPUP', 'saveName');
            dispatch('showComm', {
                text: i18n.t('popup.genDragonTips'),
                size: 'mid',
                hasCls: false
            });
            commit('SET_USERINFO', {
                user_name: data.name
            });
            setTimeout(() => {
                // 定时器，让生成提示停留1s
                commit('SET_GAME_STATE', {
                    key: 'user_name',
                    value: data.name
                });
                Bus.$emit('_goPage', 'create', () => {
                    // 生成结束，隐藏提示弹窗
                    commit('HIDE_POPUP', 'comm');
                });
            }, 1000);
        } else {
            console.log(result.msg);
        }
    },
    // 获取第三方跳转地址
    async getAuthLocation({ state }, data) {
        const request_obj = {
            url: 'v1/login/url',
            lang: state.lang,
            data
        };
        const result = await baseRequest(request_obj);
        if (result.code == 1) {
            location.href = result.data.url;
        } else {
            console.log(result.msg);
        }
    },
    // 获取中奖记录
    async getRewardList({ state }, data) {
        const request_obj = {
            url: 'v1/reward/hits',
            lang: state.lang,
            data,
            token: state.token
        };
        return await baseRequest(request_obj);
    },
    // 抽奖
    async drawReward({ state, commit, dispatch }, activeId) {
        if (drawLock) {
            return;
        }
        drawLock = true;
        const self = this;
        const request_obj = {
            url: 'v1/reward/draw',
            lang: state.lang,
            data: {
                active_id: activeId
            },
            token: state.token
        };
        const result = await baseRequest(request_obj);
        if (result.code == 1) {
            // 抽到的奖品
            const reward = result.data;
            if (
                activeId == state.activeId300 ||
                activeId == state.activeId600
            ) {
                drawLock = false;
                // 未中奖
                if (reward.status == 2) {
                    return;
                }
                const userinfo = state.userinfo;
                if (activeId == state.activeId300) {
                    userinfo.get_gift_one = 1;
                }
                if (activeId == state.activeId600) {
                    userinfo.get_gift_two = 1;
                }
                commit('SET_STATE', {
                    key: 'userinfo',
                    val: userinfo
                });
                commit('SHOW_CODE_POPUP', reward.get);
            } else {
                // 判断是否有lottery实例，无则new
                let lottery = state.lottery;
                if (!lottery) {
                    lottery = new Turntable('.popup-lottery-panel');
                    commit('SET_STATE', {
                        key: 'lottery',
                        val: lottery
                    });
                }
                commit('SET_STATE', {
                    key: 'lotteryClsShow',
                    val: false
                });
                let lotteryIndex = -1;
                const rewardType = reward.get && reward.get.type_ename;
                if (rewardType == 'once_more' || reward.status == 2) {
                    lotteryIndex = 0;
                } else {
                    lotteryIndex = reward.get && reward.get.item_id;
                }
                //转盘转到对应位置
                lottery.start(rewardMap[lotteryIndex], function(index) {
                    // 首次会被盖住
                    setTimeout(() => {
                        drawLock = false;
                        if (lotteryIndex == 0) {
                            commit('HIDE_POPUP', 'lottery');
                            dispatch('showComm', {
                                text: i18n.t('popup.draw.noReward')
                            });
                        } else {
                            commit('HIDE_POPUP', 'lottery');
                            commit('SET_STATE', {
                                key: 'drawReward',
                                val: reward.get
                            });
                            if (rewardType == 'code') {
                                // 抽中code兑换码
                                commit('SHOW_CODE_POPUP', reward.get);
                            } else if (rewardType == 'kind') {
                                // 抽中实物奖
                                commit('SHOW_POPUP', 'entity');
                            } else if (rewardType == 'shop_card') {
                                // 抽中购物卡
                                commit('SHOW_POPUP', 'giftCard');
                            }
                        }
                        dispatch('updateUserInfo');
                        commit('SET_STATE', {
                            key: 'lotteryClsShow',
                            val: true
                        });
                    }, 1000);
                });
            }
        } else {
            drawLock = false;
            if (result.code == '200008') {
                dispatch('showComm', {
                    text: i18n.t('popup.noScoreTips'),
                    size: 'big',
                    hasCls: true
                });
            } else {
                dispatch('showComm', {
                    text: result.msg,
                    size: 'big',
                    hasCls: true
                });
            }
        }
    },
    // 填写资料
    async fillDrawInfo({ state, commit, dispatch }, data) {
        const request_obj = {
            url: 'v1/reward/input',
            lang: state.lang,
            data,
            token: state.token
        };
        const result = await baseRequest(request_obj);
        console.log(result);
        if (result.code == 1) {
            commit('HIDE_ALL_POPUP');
            dispatch('showComm', {
                text: i18n.t('popup.draw.fillSucc')
            });
        } else {
            console.log(result.msg);
        }
    },
    // 获取对战结果
    async getBattleResult({ state }, data) {
        const request_obj = {
            url: 'v1/battle/result',
            lang: state.lang,
            data,
            token: state.token
        };
        const result = await baseRequest(request_obj);
        return result;
    },
    // 获取所有对战文案列表
    async getBattleList({ state }) {
        const request_obj = {
            url: 'v1/content/battle',
            lang: state.lang,
            token: state.token
        };
        const result = await baseRequest(request_obj);
        console.log(result);
        return result;
    },
    // 对战记录列表
    async getBattleHistoryList({ state }, data) {
        const request_obj = {
            url: 'v1/battle/lists',
            lang: state.lang,
            token: state.token,
            data
        };
        return await baseRequest(request_obj);
    },
    // 获取我跟好友的对战数据
    async getBattleFriList({ state }, data) {
        const request_obj = {
            url: 'v1/battleFriend/lists',
            lang: state.lang,
            token: state.token,
            data
        };
        return await baseRequest(request_obj);
    },
    // 获取标签列表
    async getTagList({ state }) {
        const request_obj = {
            url: 'v1/tag/lists',
            lang: state.lang
        };
        const result = await baseRequest(request_obj);
        console.log(result);
        return result;
    },
    // 获取星座列表
    async getStarList({ state }) {
        const request_obj = {
            url: 'v1/star/lists',
            lang: state.lang
        };
        const result = await baseRequest(request_obj);
        console.log(result);
        return result;
    },
    // 获得龙列表·
    async getDragonList({ state }) {
        const request_obj = {
            url: 'v1/dragon/lists',
            lang: state.lang
        };
        const result = await baseRequest(request_obj);
        console.log(result);
        return result;
    },
    // 获取下载积分
    async getDownloadScore({ state, commit }) {
        const userinfo = state.userinfo;
        if (userinfo && userinfo.download == 2) {
            const request_obj = {
                url: 'v1/score/download',
                lang: state.lang,
                token: state.token
            };
            const result = await baseRequest(request_obj);
            if (result.code == 1) {
                let _score_add = result.data.score; // 本次下载获得积分
                let _score_total = userinfo.score_total;
                let _score = userinfo.score;
                commit('SET_USERINFO', {
                    score: _score * 1 + _score_add * 1,
                    score_total: _score_total * 1 + _score_add * 1
                });
            }
        }
    },
    async saveShare({ state, commit }, data) {
        const userinfo = state.userinfo;
        const request_obj = {
            url: 'v1/share/add',
            lang: state.lang,
            data,
            token: state.token
        };
        const result = await baseRequest(request_obj);
        console.log(result);
        if (result.code == 1) {
            let _score_add = result.data.score; // 本次下载获得积分
            let _score_total = userinfo.score_total;
            let _score = userinfo.score;
            commit('SET_USERINFO', {
                score: _score * 1 + _score_add * 1,
                score_total: _score_total * 1 + _score_add * 1
            });
        }
    },
    // 上传图片
    async uploadImg({ state }, content) {
        const request_obj = {
            url: 'v1/upload/img',
            lang: state.lang,
            data: {
                content
            },
            token: state.token
        };
        const result = await baseRequest(request_obj);
        console.log(result);
        return result;
    }
};

export default actions;
